<template>
  <span v-html="value.oldValue || 'campo vazio'" />
</template>

<script>
export default {
  name: 'HistoricalChangeExclusionValue',

  props: { value: { type: Object, default: () => ({}) } }
}
</script>
